import { Box, keyframes, styled } from '@mui/material';

import { shouldForwardProps } from '../../utils/mui-styled.utils';

const blinker = keyframes`
	50% {
	  opacity: 0.3;
	}
  `;

interface StyledRootProps {
	isExpanded: boolean;
}

export const StyledWidgetLoadingRoot = styled(Box, {
	shouldForwardProp: shouldForwardProps(['isExpanded']),
})<StyledRootProps>(
	({
		theme: {
			palette: { sizes },
		},
		isExpanded,
	}) => ({
		position: 'absolute',
		height: '100%',
		width: '100%',
		flex: 1,
		display: 'flex',
		padding: `${sizes.size_1}px ${sizes.size_1}% 0`,
		flexDirection: 'column',
		justifyContent: 'center',
		pointerEvents: 'none',

		'& .botMessage': {
			width: isExpanded ? 284 : 254,
			height: isExpanded ? 75 : 67,
			animation: `${blinker} 1s linear infinite`,
			paddingLeft: sizes.size_1,
			position: 'absolute',
		},

		'& .buttonContent': {
			display: 'flex',
			margin: `auto auto ${sizes.size_2}px auto`,
			width: 192,
		},

		'& .animatedButton': {
			height: 48,
			width: 94,
			animation: `${blinker} 1s linear infinite`,
			'&:not(:last-of-type)': {
				marginRight: sizes.sizeHalf,
			},
		},
	}),
);
